export { View as SignFooter } from './view'
